import type { RouteObject } from "react-router-dom";
import { routeHandle } from "@/modules";
import { COMMERCE_SEGMENTS, MODELS_SEGMENTS } from "@/modules/blueprints";
import { LegacyRedirect, type LegacyRedirectSpec } from "./LegacyRedirect";

/**
 * Eski URL → yeni modül URL'i. Mail, Slack, widget ve paylaşılan linkler
 * bu adresleri taşıyor; bu liste HİÇ SİLİNMEZ, yalnızca büyür.
 *
 * Hedefler `getModuleHref` ile üretilir: subdomain'de `/shopping` → `/shop`,
 * ana domainde → `/fashion/shop`. Query string ve hash korunur.
 */

const withOptional = (value: string | undefined) => (value ? `/${value}` : "");

const LEGACY_REDIRECTS: LegacyRedirectSpec[] = [
  // commerce → fashion
  { from: "/shopping", moduleId: "fashion", segment: () => COMMERCE_SEGMENTS.shop },
  {
    from: "/instant-search",
    moduleId: "fashion",
    segment: () => COMMERCE_SEGMENTS.search,
  },
  {
    from: "/product/:id",
    moduleId: "fashion",
    segment: (p) => `${COMMERCE_SEGMENTS.product}/${p.id}`,
  },
  {
    from: "/wardrobe",
    moduleId: "fashion",
    segment: () => COMMERCE_SEGMENTS.wardrobe,
  },
  {
    from: "/my-wardrobe",
    moduleId: "fashion",
    segment: () => COMMERCE_SEGMENTS.myWardrobe,
  },

  // models
  // Eski dizin → dizinin yeni yeri; modül kökü artık kokpit
  { from: "/ai-models", moduleId: "models", segment: () => "explore" },
  {
    from: "/wizard/:id/:chatId?",
    moduleId: "models",
    segment: (p) => `${MODELS_SEGMENTS.wizard}/${p.id}${withOptional(p.chatId)}`,
  },
  { from: "/library", moduleId: "models", segment: () => MODELS_SEGMENTS.library },
  { from: "/studio", moduleId: "models", segment: () => MODELS_SEGMENTS.studio },
  {
    from: "/studio/projects",
    moduleId: "models",
    segment: () => MODELS_SEGMENTS.studioProjects,
  },
];

/**
 * Redirect route'ları. Bare + public: anında yönlendirdiği için kabuk ve
 * guard render etmenin anlamı yok — hedef route kendi guard'ını uygular.
 */
export const legacyRedirectRoutes: RouteObject[] = LEGACY_REDIRECTS.map(
  (spec) => ({
    path: spec.from,
    element: <LegacyRedirect spec={spec} />,
    handle: routeHandle({ auth: "public", layout: "bare" }),
  }),
);
